import { FC } from 'react'

import { PageContent } from 'common'
import { WarningMessage } from 'components'
import { TProduct, TUserType } from 'contexts/app-context/types'

import { WarningMessageContainer } from '../styles/ProductBr.styles'
import { MeansOfCommunication, type MeansOfCommunicationAdapter } from './means-of-communication'
import { OffersAndNews } from '../../offers-and-news/OffersAndNews'

interface ProductViewProps {
  marketingNotificationsSection: TProduct<TUserType>['marketingNotificationsSection']
  alertSection: TProduct<TUserType>['alertSection']
  hasTransactionalNotifications: boolean
  communications: MeansOfCommunicationAdapter
}

export const ProductView: FC<ProductViewProps> = ({
  alertSection,
  marketingNotificationsSection,
  hasTransactionalNotifications,
  communications,
}) => (
  <PageContent
    padding={{
      top: hasTransactionalNotifications ? '0px' : '24px',
      left: '24px',
      right: '24px',
      bottom: '24px',
    }}
  >
    <OffersAndNews
      title={marketingNotificationsSection.title}
      description={marketingNotificationsSection.details}
    />
    <MeansOfCommunication adapter={communications} />
    <WarningMessageContainer>
      <WarningMessage {...alertSection} size={16} />
    </WarningMessageContainer>
  </PageContent>
)
